var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileBurgerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.527,
    height: 32.527,
    viewBox: "0 0 32.527 32.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956",
    transform: "translate(-321.883 -49.383)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x2: 38,
    transform: "translate(324.711 79.081) rotate(-45)",
    fill: "none",
    stroke: "#106da0",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109-2",
    "data-name": "Line 109",
    y1: 37,
    transform: "translate(325.418 52.919) rotate(-45)",
    fill: "none",
    stroke: "#106da0",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBurgerClose);
export default __webpack_public_path__ + "static/media/mobile-burger-close.691bfab21b2e9988b27b8446b1f6e962.svg";
export { ForwardRef as ReactComponent };